module.exports = __webpack_public_path__ + "202408221624/img/home_summer_avatar.d860677d.jpg";